export const getActivities = ({ activities }) => activities.activities;
